import React from "react";
import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { CaretLeft } from "@phosphor-icons/react";
import AvatarEdit from "./AvatarEdit";
import { CroppedAvatar } from "@answersnow/pkg-theme";
import getAvatarInitials from "utils/getAvatarInitials";

interface HeaderMainTitleProps {
  user: any;
  title: string;
  onBack?: () => void;
  icon?: React.ElementType;
  onAvatarSuccess?: (imageUrl: string) => void;
}

export const HeaderMainTitle: React.FC<HeaderMainTitleProps> = ({
  user,
  title,
  onBack,
  icon: Icon,
  onAvatarSuccess
}) => {
  const userFullName = user?.first_name
    ? `${user.first_name} ${user.last_name ?? ""}`.trim()
    : "";
  const userInitials = getAvatarInitials(userFullName);
  const avatarUrl = user?.imageUrl || user?.image_url;

  return (
    <>
      {onBack && (
        <Box sx={{ display: "flex", justifyContent: "flex-start", padding: "24px" }}>
          <IconButton onClick={onBack} sx={{ color: "#666" }}>
            <CaretLeft size={24} />
          </IconButton>
        </Box>
      )}
      <Box sx={{ padding: "0 24px" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1, justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {Icon ? (
              <Box sx={{ mr: 3, display: "flex", alignItems: "center" }}>
                <Icon size={40} weight="duotone" color="#8E42CA" />
              </Box>
            ) : (
              <CroppedAvatar
                src={avatarUrl}
                alt={userFullName}
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: "#8E42CA",
                  color: "#ffffff",
                  mr: 3,
                }}
              >
                {userInitials}
              </CroppedAvatar>
            )}

            <Typography variant="h2" sx={{ fontWeight: 500, fontSize: "32px" }}>
              {title}
            </Typography>
          </Box>

          {user?.id && onAvatarSuccess && (
            <AvatarEdit
              userId={user.id}
              currentImageUrl={avatarUrl}
              onSuccess={onAvatarSuccess}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
